import React from "react";
import TurnrInput from "~/components/input/TurnrInput.jsx";
import { InputGridWrapper, SettingsContainerWrapper } from "./settingComponents";
import { INGRID_SUPPORT_EMAIL } from "rylak-common/src/constants";

export default function ShopInfoSettings(props) {
    return (
        <SettingsContainerWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    tooltip="Sometimes we need to display the name of your company through the app or generated emails."
                    label="Shop Name"
                    fullWidth
                    {...props.displayName}
                    onChange={props.setDisplayName}
                    required
                />
            </InputGridWrapper>
            <InputGridWrapper style={{ position: "relative" }}>
                <TurnrInput
                    size={"small"}
                    tooltip="We need the url to your store website for example when we link back to your store at the end of a successful return. For example https://example.se/"
                    label="Shop url"
                    fullWidth={true}
                    {...props.homePage}
                    onChange={props.setHomePage}
                />
            </InputGridWrapper>
            <InputGridWrapper style={{ position: "relative" }}>
                <TurnrInput
                    size={"small"}
                    tooltip={"In some places in the return app we link to the support email you choose here. Defaults to " + INGRID_SUPPORT_EMAIL}
                    label="Support email"
                    placeholder={INGRID_SUPPORT_EMAIL}
                    fullWidth={true}
                    {...props.supportEmail}
                    error={props?.supportEmailError}
                    onChange={props.setSupportEmail}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    tooltip="The page title that is visible on top of a browser window. Usually the browser tab name"
                    label="Html Page Title"
                    fullWidth={true}
                    {...props.htmlPageTitle}
                    onChange={props.setHtmlPageTitle}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    tooltip="The icon that is shown next to the html page title on a browser tab"
                    label="Html Favicon"
                    fullWidth={true}
                    {...props.htmlFavicon}
                    onChange={props.setHtmlFavicon}
                />
            </InputGridWrapper>
        </SettingsContainerWrapper>
    );
}
